module.exports = __webpack_public_path__ + "static/media/message-arrow-boards.7e0ea531.jpg";